export default "__VITE_PUBLIC_ASSET__d77a2db4__"